import React from 'react';
import { useSelector } from 'react-redux';
import { selectPRLoader } from 'src/store/selectors/PropertyLoader';
import { selectAuthenticatedUser } from 'src/store/selectors/auth';
import ModernizedNotes from 'src/components/Notes/ModernizedNotes';
import { UseNotesAPIReturn } from 'src/SharedCustomHooks/UseNotesAPI/useNotesAPI';

const HIDDEN_ADD_ROLES: string[] = [
  'Vendor',
  'Home Owner',
  'Realtor',
  'Occupant',
];

interface SuiteNotesProps {
  suite: any;
  notesAPI: UseNotesAPIReturn;
  onFetchSuiteData: () => void;
}

const SuiteNotes = ({ suite, notesAPI, onFetchSuiteData }: SuiteNotesProps) => {
  const user: any = useSelector(selectAuthenticatedUser);
  const prLoader: any = useSelector(selectPRLoader);

  const userRole: any = user?.roles?.[0]?.role?.name || '';
  const canAddNotes: boolean = !HIDDEN_ADD_ROLES.includes(userRole);

  const isLoading: boolean =
    prLoader || (notesAPI.loadingNotes && notesAPI.notes.length === 0);

  const refreshSuite = (): void => {
    void onFetchSuiteData();
  };

  return (
    <ModernizedNotes
      notesAPI={notesAPI}
      entityId={suite.id}
      itemType="Suite"
      userId={user.id}
      canAddNote={canAddNotes}
      canDelete={true}
      loading={isLoading}
      afterMutate={refreshSuite}
      addDialogTitle="Add Suite Note"
      editDialogTitle="Edit Suite Note"
      addDialogDescription="Add a private or resident-visible note for this suite."
      showHomeownerVisibilityCheckbox={true}
    />
  );
};

export default SuiteNotes;
